<menu-desktop [node]="node!" *limitUp="DEVICE_SIZE.DESKTOP"></menu-desktop>

<menu-mobile [node]="node!" *smallerThan="DEVICE_SIZE.DESKTOP"></menu-mobile>
